"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIST_NAME_MAX_LENGTH = exports.LIST_DESCRIPTION_MAX_LENGTH = exports.DATA_TESTID = exports.CREATE_OR_EDIT_CONTENT_SUBMIT = exports.CREATE_OR_EDIT_CONTENT_NAME = exports.CREATE_OR_EDIT_CONTENT_DESCRIPTION = exports.CREATE_OR_EDIT_CONTENT = void 0;
const DATA_TESTID = exports.DATA_TESTID = 'data-testid';
const LIST_NAME_MAX_LENGTH = exports.LIST_NAME_MAX_LENGTH = 100;
const LIST_DESCRIPTION_MAX_LENGTH = exports.LIST_DESCRIPTION_MAX_LENGTH = 250;
const CREATE_OR_EDIT_CONTENT = exports.CREATE_OR_EDIT_CONTENT = 'create-or-edit-content';
const CREATE_OR_EDIT_CONTENT_SUBMIT = exports.CREATE_OR_EDIT_CONTENT_SUBMIT = 'create-or-edit-content-submit';
const CREATE_OR_EDIT_CONTENT_NAME = exports.CREATE_OR_EDIT_CONTENT_NAME = 'create-or-edit-content-name';
const CREATE_OR_EDIT_CONTENT_DESCRIPTION = exports.CREATE_OR_EDIT_CONTENT_DESCRIPTION = 'create-or-edit-content-description';
//# sourceMappingURL=constants.js.map